import { CancelOfferRequestForAdminState } from './cancelOfferRequestForAdmin.types'

const cancelOfferRequestForAdminInitialState: CancelOfferRequestForAdminState = {
  loading: false,
  error: null,
  success: null
}

export default cancelOfferRequestForAdminInitialState
